<template>
    <div style="display: flex;flex-direction: row">

      <div class="left_nav_content hide-scrollbar">
        <div class="logo">
          <img src="../assets/img/logo.png" alt="">
        </div>
        <div class="Student_info_content">
          <div class="Student_img_content" @click="local_addClildren">
            <img class="winm_icon" :src="children_info.avatar" alt="">
            <div class="Student_Name">{{children_info.nickname}}
            </div>
          </div>

          <div class="Student_Name1">
<!--            <img src="../assets/img/link_icon.png" alt=""><span>复制链接</span>-->
            本月课程数量
          </div>

          <div class="size_content_box">
            <div class="Completed">
              <div class="number_size">{{children_info.month_complete}}</div>
              <div class="number_content">{{$t('new_index.Completed')}}</div>
            </div>
            <div class="Completed">
              <div class="number_size">{{children_info.month_pending}}</div>
              <div class="number_content">{{$t('new_index.Scheduled')}}</div>
            </div>
            <div class="Scheduled">
              <div class="number_size">{{children_info.month_no_show}}</div>
              <div class="number_content">{{$t('new_index.NoShow')}}</div>
            </div>
          </div>
        </div>
        <div class="nav_list_content">
          <ul>
            <router-link class="bj" to="/home/children/AttendClassNow">
              <li>
                <div>
                  <img class="left_icon" src="../assets/img/nav1IconColor.png" alt="">
                  <a href="javascript:;">{{$t('new_index.Attend_Class_Now')}}</a>
                </div>
                <img class="right_icon" src="../assets/1IconColor.png" alt="">
              </li>
            </router-link>
            <router-link class="bj" to="/home/children/ClassEnrolled">
              <li>
                <div>
                  <img class="left_icon" src="../assets/img/Path.png" alt="">
                  <a href="javascript:;">{{$t('new_index.Class_Enrolled')}}</a>
                </div>
                <img class="right_icon" src="../assets/1IconColor.png" alt="">
              </li>
            </router-link>
            <router-link class="bj" to="/home/children/ViewCompletedLessons">
              <li>
                <div>
                  <img class="left_icon" src="../assets/img/Stroke1kem.png" alt="">
                  <a href="javascript:;">{{$t('new_index.View_Completed_Lessons')}}</a>
                </div>
                <img class="right_icon" src="../assets/1IconColor.png" alt="">
              </li>
            </router-link>
            <a class="bj" :href="jumpUrl" target="_blank">
              <li>
                <div>
                  <img class="left_icon" src="../assets/img/Buy.png" alt="">
                  <a>{{$t('new_index.Purchase_Lesson_Plan')}}</a>
                </div>
                <img class="right_icon" src="../assets/1IconColor.png" alt="">
              </li>
            </a>
            <!-- 地址 -->
            <router-link class="bj" to="/home/children/Address">
              <li>
                <div>
                  <img class="left_icon" src="../assets/img/address.png" alt="">
                  <a href="javascript:;">{{$t('new_index.Address')}}</a>
                </div>
                <img class="right_icon" src="../assets/1IconColor.png" alt="">
              </li>
            </router-link>
            <!--    录播课        -->
            <router-link class="bj" to="/home/children/Videoclass">
              <li>
                <div>
                  <img class="left_icon" src="../assets/img/video.png" alt="">
                  <a href="javascript:;">{{$t('new_index.Videoclass')}}</a>
                </div>
                <img class="right_icon" src="../assets/1IconColor.png" alt="">
              </li>
            </router-link>
            <!--    作业        -->
            <router-link class="bj" to="/home/children/Homework">
              <li>
                <div>
                  <img class="left_icon" src="../assets/img/homework.png" alt="">
                  <a href="javascript:;">{{$t('new_index.Homework')}}</a>
                </div>
                <img class="right_icon" src="../assets/1IconColor.png" alt="">
              </li>
            </router-link>
          </ul>
          <div class="shiqu_content">
            <img class="icon_shiqu" src="../assets/TimeCircle.png" alt="">
            <span class="shiqumm">{{$t('index.timeZone')}}{{utils.globetime()}}</span>
          </div>
        </div>
      </div>
      <div class="right_content">
        <Header ref="children" ></Header>
        <router-view></router-view>
      </div>
      <!--左侧导航栏目视图-->
<!--      <div class="left_body_content">-->
<!--        <div class="right_content">-->
<!--      <Header ref="children" ></Header>-->
<!--            <router-view></router-view>-->
<!--        </div>-->
<!--      </div>-->


      <el-dialog :visible.sync="dialogTableVisible" width="40%">
          <div class="sk1">{{$t('new_index.Dear_customer')}}: </div>
          <div class="sk1">{{$t('new_index.If')}}</div>
          <div class="sk1">{{$t('new_index.Please')}}</div>
          <div class="ik_keihssa sdimw"><img class="immkkll dh" src="../assets/Stroke1.svg" alt="">{{user_info.mobile}}</div>
          <div class="kiweixin sdimw"><img class="immkkll wxa" src="../assets/WeChat_lgo_icon1.svg" alt="">Wechat ID: {{user_info.wechat}}</div>
          <img class="ewm_img" :src="user_info.qr_code" alt="">
          <div style="text-align:center;margin:10px 0">请扫码添加顾问老师微信</div>
      </el-dialog>

    </div>
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  import IndexHeader from './views/header'
  import IndexFooter from './views/footer'
  import MyScheduled from './views/scheduled'
  import MyCourse from './views/course'
  import PastLesson from './views/lesson'

  //引入header组件
  import Header from './header/header'

  export default {
    inject:['reload'],
    components: {
      IndexHeader,
      IndexFooter,
      MyScheduled,
      PastLesson,
      MyCourse,
      Header
    },
    data () {
      return {
        height:100,
        data:[],
        children_info:[],
        dialogTableVisible:false,
        user_info:[],
        balanceData:{},
        jumpUrl:'',
        leftheight:'929px'
      }
    },
    created () {
      this.jumpUrl = window.location.origin+'/goods/cn/'
      if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.get_one_id();
      // 用户信息
      this.getUser()
      // 账户信息
      // this.getBalance()
      /**
       * 获取销售用户信息
       */
      this.Sales_information();
      // 孩子信息
      // this.getChild()
      // 搜索全部正在上和还没上的课
      // this.search()
      // if (this.$route.query.type == 1) {
      //   this.activeTitle = 'course'
      // } else {
      //   this.activeTitle = 'schedule'
      // }
    },
    methods: {
      /**
       * 打开弹窗
       */
      show_moodel(){
        this.dialogTableVisible = true;
      },
      /**
       * 获取默认的孩子ID
       */
      get_one_id:function(){
        let _this = this;
        this.$http.get('/api/students').then((res) => {
          if (res.data.code == 200) {
              console.log('孩子',res)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      /**
       * 点击头像跳转添加孩子页面
       */
      local_addClildren:function(){
        this.$router.push({path: '/home/children/addChildren'})
      },
      handleClick (tab, event) {
        console.log(tab, event)
        this.$router.push(this.$route.path)
        if (tab.name == 'course') {
          this.getCourse()
        } else if (tab.name == 'schedule') {
          this.getschedule()
        } else if (tab.name == 'lesson') {
          this.getLesson()
        }
      },
      toRecharge () {
        this.$router.push({path: '/recharge'})
      },
      //获取默认孩子信息
      getUser () {
        this.$http.get('/api/user/profile').then((res) => {
          if (res.data.code == 200) {
            this.data = res.data.data
            this.children_info = res.data.data.student_info
            setStore(keys.userProfile, res.data.data)
            this.$refs.children.up();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      // getChild () {
      //   this.$http.get('/api/students').then((res) => {
      //     if (res.data.code == 200) {
      //       console.log(res)
      //       this.childData = res.data.data
      //       store.setChildList(res.data.data)
      //     } else {
      //       this.$message({
      //         message: res.data.msg,
      //         type: 'warning'
      //       })
      //     }
      //   }).catch((error) => {
      //     console.log(error) // 请求失败返回的数据
      //   })
      // },
      search () {
        setStore(keys.searchFilter, this.searchStudentSn)
        // 我的时间表
        this.getschedule()
        this.getCourse()
        this.getLesson()
      },
      editChild () {
        this.$router.push({path: '/allChild'})
      },
      getschedule () {
        console.log('=============================this')
        // console.log(this)
        // console.log(navigator.language)
        // let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
        this.$http.get('/api/userSchedukeForStudent?type=1001&student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone() + '&pagesize=' + this.pagesize + '&page=' + this.pageNum).then((res) => {
          if (res.data.code == 200) {
            this.scheduleData = res.data.data
            this.now_status = res.data.now_status
            this.total = res.data.total
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getCourse () {
        this.$http.post('/api/myCourse?student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            console.log(res)

            this.courseData = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      getLesson () {
        this.$http.get('/api/getCompletedLessonPC?student_sn=' + this.searchStudentSn + '&time_diff=' + this.utils.timeZone()).then((res) => {
          if (res.data.code == 200) {
            this.lessonData = res.data.data
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
      toPayList () {
        this.$router.push({path: '/payHistory'})
      },
      RepeatSchedule (data) {
        if (data) {
          this.getschedule()
        }
      },
      handleCurrentChange (val) {
        this.pageNum = val
        this.getschedule()
      },
      /**
       * 获取销售信息
       */
      Sales_information:function(){
        // console.log('测试：',navigator.language)
        let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
        this.$http.get('/api/getUserInfo', {headers: {token:getStore(keys.token)}}).then((res) => {
          if (res.data.code == 200) {
            setStore(keys.user, res.data.data)
            this.user_info = res.data.data.salesperson_info
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      },
    },
    mounted () {
      let _this = this //很关键是要把父路由的vue实例赋给_this
      this.$root.$on("addDpm", function() {
          _this.show_moodel();
      });
    },
  }
</script>
<style lang="less" scoped>
.left_nav_content{
  width: 280px !important;
  background: #FF6E17;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  .logo{
    height: 68px;
    position: relative;
    display: flex;
    justify-content: center;
    img{
      position: absolute;
      bottom: 0;
    }
  }
  .Student_info_content{
    width: 281px;
    // height: 202px;
    //border-bottom: 1px solid #EEF0FF;
    margin: 0 auto 0 auto;
    .Student_img_content{
      text-align: center;
      cursor: pointer;
    }
    .Student_Name{
      font-family: Roboto;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0px;

      font-feature-settings: "kern" on;
      color: #FFFFFF;
    }
    .Student_Name1{
      text-align: center;
      padding: 18px 0 23px;
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0px;

      font-feature-settings: "kern" on;
      color: #FFFFFF;
      img{
        width: 17.5px;
        height: 12.88px;
      }
      span{
        display: inline-block;
        margin-left: 4.5px;
      }
    }
    .size_content_box{
      //width: 231px;
      //margin: 0px auto 0 auto;
      display: flex;
      margin-bottom: 48px;
      .Completed{
        width: 95px;
      }
      .Scheduled{
        width: 95px;
      }
    }
  }
  .nav_list_content{
     width: 281px;
    //width:358px;
    height: 270px;
    //border: 0px solid red;
    margin: 0 auto 0 auto;
    li{
      width: 231px;
      height: 54px;
      //border: 0px solid red;
      margin: 0 auto 0 auto;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      div{
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .left_icon{
        //width: 22px;
        height: 16px;
        margin-top: 16px;
        float: left;
      }
      a{
        margin-left: 22px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        align-items: center;
        color: #fff;
        float: left;
        margin-top: 17px;
      }
      .right_icon{
        float: right;
        margin-top: 21px;
      }
    }
  }
}

.right_content{
  width: calc(100vw - 280px);
  min-width: 902px;
  margin-left: 280px;
}

.number_size{
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 16px;
    text-align: center;
    color: #fff;
    margin-top: -5px;
}
.number_content{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: #fff;
    margin-top: 6px;
}
.bj{
  display: block;
}
.router-link-active{
  background: rgba(75, 105, 254, 0.08);
}
.winm_icon{
  width:64px;
  height:64px;
  border-radius: 100%;
  margin:26px auto 0;
}
.icon_shiqu{
  width:14px;
  height:14px;
  display: inline-block;
  float: left;
  margin-top: 18px;
}
.shiqumm{
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;

  font-feature-settings: "kern" on;
  color: #fff;
  display: inline-block;
  float: left;
  margin: 20px 0 0 8px;
}
.shiqu_content{
  width: 281px;
  height: 54px;
  margin: 0px auto 0 24px;
  padding-top:35px;
  //position: absolute;
  //bottom: 24px;
  //left: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.simaaaa{
  Width :15.68px;
  Height:17.44px;
  margin-left: 15px;
  cursor: pointer;
}
.ik_keihssa{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 15px;
  /* identical to box height, or 93% */
  color: #0B1D33;
  // text-align: center;
  margin-top:30px;
}
.kiweixin{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 15px;
  /* identical to box height, or 93% */
  color: #0B1D33;
  // text-align: center;
  margin-top:30px;
}
.sk1{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 20px !important;
  line-height: 20px;
  text-align: center;
  color: #000000;
  margin-bottom: 10px;
}
.sdimw{
  width: 326px !important;
  // border: 1px solid red;
  margin: 40px auto 0 auto !important;
}
.dh{
  position: relative;
  top: 6px;
  margin-right: 20px;
}
.wxa{
      position: relative;
    top: 8px;
    margin-right: 14px;
}
.ewm_img{
    width: 106px;
    height: 106px;
  margin:40px auto 0 auto;
  display: block;
  border:4px solid #4B69FE;
  border-radius: 10px;
}
/* 目标元素：可替换为 body、.container 等需要隐藏滚动条的元素 */
.hide-scrollbar {
  /* 1. 基础：确保元素可滚动（必须设置，否则无滚动效果） */
  overflow-y: auto; /* 垂直滚动（根据需求可换 overflow-x: auto 控制水平） */
  /* 2. 兼容 Firefox */
  scrollbar-width: none;
  /* 3. 兼容 IE 和 Edge */
  -ms-overflow-style: none;
}

/* 4. 兼容 WebKit 内核浏览器（Chrome、Safari、Edge 新版、Opera） */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue